import _ from "lodash";
import 'CssFolder/widgets.scss';

export default function SmallTextWidgetComponent() {
  let title;
  let mainText;
  let secondaryText;
  let additionalText;
  let style;

  return {
    view: function (vnode) {
      title = vnode.attrs.title;
      mainText = vnode.attrs.mainText;
      secondaryText = vnode.attrs.secondaryText;
      additionalText = vnode.attrs.additionalText;
      style = _.isEmpty(vnode.attrs.style) ? '' : vnode.attrs.style;
      return [
        m('.card.small-text-widget.widget-component',
          {
            onclick: () => {
              if (vnode.attrs.handleFilterAbnormalTypeAttendance) {
                vnode.attrs.handleFilterAbnormalTypeAttendance()
              }
            },
            class: vnode.attrs.class,
            style: 'flex-grow: 1; flex-basis:0;' + style
          }, [
          m('.card-body.d-flex.flex-column.justify-content-between', [
            !_.isEmpty(title) && m('.title', title),
            m('.right', [
              (!_.isEmpty(mainText) || !_.isEmpty(secondaryText)) &&
              m('', [
                !_.isEmpty(mainText) && m('span.main-text', mainText),
                !_.isEmpty(secondaryText) && m('span.secondary-text.ms-2', '(' + secondaryText + ')'),
              ]),
              !_.isEmpty(additionalText) && m('.additional-text', additionalText),
            ]),
          ]),
        ]),
      ]
    }
  }
}
